// extracted by mini-css-extract-plugin
module.exports = {"close":"styles_close__3nVBr","closeCrossGray":"styles_closeCrossGray__3mdQi","closeCrossRed":"styles_closeCrossRed__2AvVA","closeCross":"styles_closeCross__iWizK"};